import React from 'react';
import type { PropsWithChildren } from 'react';

type StickyCTABarContextProps = {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
};

const StickyCTABarContext = React.createContext<StickyCTABarContextProps>({
  visible: false,
  setVisible: () => null,
});

export const StickyCTABarContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [visible, setVisible] = React.useState(false);

  return (
    <StickyCTABarContext.Provider value={{ visible, setVisible }}>
      {children}
    </StickyCTABarContext.Provider>
  );
};
